import {
  NEW_MATCH_STATUSES,
  MATCH_STATUS_ALIASES,
  MATCH_STATUS_LABELS,
  PAST_MATCH_STATUSES,
} from '@/constants/match-statuses';
import { parseQueryArray } from '@/utils/parse-query';
import {
  URGENCY_LABELS,
  DEFAULT_URGENCY,
} from '@/constants/urgencies';

export const JOBS_QUERY_PARAMS = {
  STATUSES: 's',
  QUERY: 'q',
  IDS: 'j',
  SUB_STATUSES: 'b',
};

export default {
  MATCH_STATUSES: NEW_MATCH_STATUSES,
  PAST_MATCH_STATUSES,
  MATCH_STATUS_LABELS,
  JOBS_STATUS_ALIASES: MATCH_STATUS_ALIASES,
  JOBS_QUERY_PARAMS,
  URGENCY_LABELS,
  DEFAULT_URGENCY,
  computed: {
    jobsStatusAlias () {
      return this.$route.params.jobsStatusAlias;
    },
    jobId () {
      return this.$route.params.jobId;
    },
    customJobsQuery () {
      return this.$route.query[this.$options.JOBS_QUERY_PARAMS.QUERY];
    },
    customJobsIds () {
      return parseQueryArray(this.$route.query[this.$options.JOBS_QUERY_PARAMS.IDS]);
    },
    customJobsStatuses () {
      return parseQueryArray(this.$route.query[this.$options.JOBS_QUERY_PARAMS.STATUSES]);
    },
    customJobsSubStatuses () {
      return parseQueryArray(this.$route.query[this.$options.JOBS_QUERY_PARAMS.SUB_STATUSES]);
    },
    isNewStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.new);
    },
    isPotentialStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.potential);
    },
    isHiredStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.hired);
    },
    isCompletedStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.completed);
    },
    isPastStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.past);
    },
    isSearchStatusAlias () {
      return this.isStatusAlias(this.$options.JOBS_STATUS_ALIASES.search);
    },
    isPastOrSearchStatusAlias () {
      const { past, search } = this.$options.JOBS_STATUS_ALIASES;

      return [past.key, search.key].includes(this.jobsStatusAlias);
    },
    urgency () {
      switch (this.job.urgency_id) {
        case 1:
        case 2:
        case 5:
          return this.$options.URGENCY_LABELS[1];
        case 3:
        case 4:
        case 6:
          return this.$options.URGENCY_LABELS[2];
        default:
          return this.$options.URGENCY_LABELS[this.$options.DEFAULT_URGENCY];
      }
    },
  },
  methods: {
    isStatusAlias ({ key }) {
      return this.jobsStatusAlias === key;
    },
  },
};
